import React, { useRef } from 'react';
import T from 'prop-types';
import cx from 'classnames';

import { useTableScrollState } from '../../../../../components/StickyTableLayout/hooks';
import { useCombinedRef } from '../../../../../hooks';
import ForecastsTable from '../../../../app-insights/_shared/components/Forecasts/ForecastsTable';

const ForecastsTableScrollableContainer = ({ activeForecast, scrollableContainerRef }) => {
  const tableContainerRef = useRef();
  const scrollState = useTableScrollState(tableContainerRef);

  return (
    <div
      className={cx('forecast-table-scrollable-container', {
        'r-scroll-active': scrollState.right,
        'l-scroll-active': scrollState.left,
      })}
    >
      <div
        ref={useCombinedRef(tableContainerRef, scrollableContainerRef)}
        className="forecast-table-scrollable-inner"
      >
        <ForecastsTable activeForecast={activeForecast} calculateCellWidth={false} />
      </div>
    </div>
  );
};

ForecastsTableScrollableContainer.propTypes = {
  activeForecast: T.object,
  scrollableContainerRef: T.object,
};

export default ForecastsTableScrollableContainer;
